import styled from 'styled-components';

export const LanguageSelectionContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1.5rem auto 1fr;
  grid-auto-rows: auto;
  align-self: flex-start;
  margin-bottom: 1.25rem;
  & span {
    bottom: 1.5rem;
  }
`;

export const Disclaimer = styled.div`
  margin-bottom: 1.5rem;
  font-size: 0.8rem;
  text-align: center;
`;

export const ModalAdditionalContentWrapper = styled.div`
  padding: 0 20px;
`;

export const LanguageSelectionCell = styled.div`
  height: 100%;
  border-bottom: 1px solid #eeeaea;
`;
